const CreateIcon = ({ className }: { className?: string }) => (
  <svg
    width="21"
    height="24"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.07219 0C3.19239 0 2.34862 0.31607 1.7265 0.87868C1.10438 1.44129 0.754883 2.20435 0.754883 3V21C0.754883 21.7956 1.10438 22.5587 1.7265 23.1213C2.34862 23.6839 3.19239 24 4.07219 24H17.3414C18.2212 24 19.065 23.6839 19.6871 23.1213C20.3092 22.5587 20.6587 21.7956 20.6587 21V8.121C20.6585 7.32542 20.3089 6.56248 19.6868 6L14.0241 0.879C13.4021 0.316352 12.5585 0.000169912 11.6788 0H4.07219ZM12.3655 9C12.3655 8.60218 12.1907 8.22064 11.8797 7.93934C11.5686 7.65804 11.1467 7.5 10.7068 7.5C10.2669 7.5 9.84502 7.65804 9.53396 7.93934C9.2229 8.22064 9.04815 8.60218 9.04815 9V12H5.73084C5.29094 12 4.86906 12.158 4.558 12.4393C4.24694 12.7206 4.07219 13.1022 4.07219 13.5C4.07219 13.8978 4.24694 14.2794 4.558 14.5607C4.86906 14.842 5.29094 15 5.73084 15H9.04815V18C9.04815 18.3978 9.2229 18.7794 9.53396 19.0607C9.84502 19.342 10.2669 19.5 10.7068 19.5C11.1467 19.5 11.5686 19.342 11.8797 19.0607C12.1907 18.7794 12.3655 18.3978 12.3655 18V15H15.6828C16.1227 15 16.5446 14.842 16.8556 14.5607C17.1667 14.2794 17.3414 13.8978 17.3414 13.5C17.3414 13.1022 17.1667 12.7206 16.8556 12.4393C16.5446 12.158 16.1227 12 15.6828 12H12.3655V9Z"
    />
  </svg>
);

export default CreateIcon;
